import { components } from '@/@types/UserActivityApi';

export function addFavourite(entityType: string, entityID: string, accessToken: string): Promise<boolean> {
  const url = `${process.env.NEXT_PUBLIC_SBS_FAVOURITES_API_HOST}/favourite`;

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
    body: JSON.stringify([{
      entityID,
      entityType,
    }]),
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          console.error('Unauthorised');
        } else {
          console.error(`HTTP error! Status: ${response.status}`);
        }
        return false;
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      return false;
    });
}

export function fetchAllFavourites(accessToken: string): Promise<components['schemas']['models.FavouriteResponse'][]> {
  const url = `${process.env.NEXT_PUBLIC_SBS_FAVOURITES_API_HOST}/favourite`;

  return fetch(url, {
    method: 'GET',
    headers: {
      ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    },
  })
    .then((response) => {
      if (!response.ok) {
        if (response.status === 401) {
          console.error('Unauthorised');
        } else {
          console.error(`HTTP error! Status: ${response.status}`);
        }
        return { movies: [], program: [] };
      }
      return response.json();
    })
    .catch((error) => {
      console.error(error);
      return { movie: [], program: [] };
    });
}

const FavouritesApi = {
  addFavourite,
  fetchAllFavourites,
};

export default FavouritesApi;
